'use client'

import { FC } from 'react'

import '@/components/Layout/Footer/Organisms/BackToTop/BackToTop.scss'

type Props = {
  onClickBackToTop?: (() => void) | null
}

const BackToTop: FC<Props> = ({ onClickBackToTop = null }) => {
  return (
    <div className="c-footer__backTop">
      <div
        className="c-link u-mo-crop"
        onClick={
          onClickBackToTop != null
            ? onClickBackToTop
            : () => {
                window.scroll(0, 0)
              }
        }
      >
        <figure className="c-footer__backTop-arrow">
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.0908 3.50005L0.654458 6.8546L4.13324 3.50006L0.654457 0.145509L11.0908 3.50005Z"
              fill="white"
            />
          </svg>
        </figure>
        <div className={'u-mo-crop__container c-footer__backTop-text'}>
          <span className="u-mo-crop__text u-mo-crop__text--inner">Back to Top</span>
          <span className="u-mo-crop__text u-mo-crop__text--outer">Back to Top</span>
        </div>
      </div>
    </div>
  )
}

export default BackToTop
